<button (click)="openApp()">Open App</button>
